import type { FixtureSummary } from "../shared/report";

interface FixtureGalleryProps {
  fixtures: FixtureSummary[];
  selectedId: string | null;
  busy: boolean;
  onSelect: (fixture: FixtureSummary) => void;
}

export function FixtureGallery({ fixtures, selectedId, busy, onSelect }: FixtureGalleryProps) {
  return (
    <section className="fixture-section" aria-labelledby="guided-examples-title">
      <div className="section-heading compact-heading">
        <div>
          <p className="eyebrow">No keys, no wallet, no chaos</p>
          <h2 id="guided-examples-title">Meet four tiny coin plot twists</h2>
        </div>
        <p>Every example uses clearly made-up data. Pick one, get the answer, then open the receipts if you are curious.</p>
      </div>
      <div className="fixture-grid">
        {fixtures.map((fixture) => (
          <button
            type="button"
            key={fixture.id}
            className={`fixture-card fixture-${fixture.tone}${selectedId === fixture.id ? " is-selected" : ""}`}
            onClick={() => onSelect(fixture)}
            disabled={busy}
            aria-pressed={selectedId === fixture.id}
          >
            <span className="fixture-topline">
              <span className="eyebrow">{fixture.eyebrow}</span>
              <span aria-hidden="true">↗</span>
            </span>
            <strong>{fixture.title}</strong>
            <span>{fixture.description}</span>
            <small>{fixture.lesson}</small>
          </button>
        ))}
      </div>
    </section>
  );
}
